<template>
    <div class="product-content">
        <!-- 搜索弹窗（如需保留，可放到内容组件；建议抽离为全局组件） -->
        <!-- <div class="search" v-show="searchVisible">
            <div class="sc_bj">
                <div class="sc_gb" @click="toggleSearch"><i class="iconfont icon-guanbi1"></i></div>
                <div class="sc_nr">
                    <input type="text" v-model="searchKeyword" placeholder="Please enter keywords">
                    <button @click="handleSearch"><i class="iconfont icon-tubiaozhizuomoban"></i></button>
                    <div class="clear"></div>
                </div>
            </div>
        </div> -->

        <!-- 产品主体区域（核心内容） -->
        <div class="product">
            <div class="container">
                <div class="row">
                    <!-- 产品分类侧边栏 -->
                    <div class="cp_lm">
                        <div class="lm_nr" :class="{ on: isSideOn, on_a: isSideOnA }">
                            <div class="b_t">Product Category</div>
                            <ul>
                                <li
                                    @click="nowIndex = -1; searchKey = ''; nowPge = 1; nowPsz = 12; handleTypeClick({ id: -1 });">
                                    <div class="y_j"><a href="javascript:;">ALL<i
                                                class="iconfont icon-zuojiantou"></i></a>
                                    </div>
                                </li>
                                <li v-for="(item, index) in productTypes" :key="index"
                                    @click="activeCategory = item.id;">
                                    <div class="y_j"><a href="javascript:;">{{ item.value }}<i
                                                class="iconfont icon-zuojiantou"></i></a></div>
                                    <div class="e_j" v-show="activeCategory == item.id">
                                        <p v-for="(subItem, subIndex) in item.data" :key="subIndex" style="cursor: pointer;"
                                            @click="handleTypeClick(subItem)"><a>{{ subItem.value }}</a></p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <!-- 产品列表 -->
                    <div class="cp_zs" ref="productList">
                        <div class="zs_lb">
                            <ul>
                                <li v-for="(item, index) in productList" :key="index"><a
                                        :href="`/product_xq/${item.id}`">
                                        <div class="t_p"><img :src="`https://cdn.bosscaigou.com/${item.himg}`"></div>
                                        <div class="w_z">
                                            <span>{{ item?.productsType?.value }}</span>
                                            <h1>{{ item.name }}</h1>
                                            <i>Read More +</i>
                                        </div>
                                    </a></li>
                            </ul>
                        </div>

                        <!-- 分页 -->
                        <el-pagination class="com-aonaer-wm-pagination" size="" background
                            @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="nowPge"
                            :page-sizes="[12, 24, 36, 48]" :page-size="nowPsz" layout="prev, pager, next"
                            :total="maxSize">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <div class="zx_bd">
            <div class="container">
                <h1>Get in touch</h1>
                <p>Our dedicated team is here to help and answer any questions you might have.<br><br>
                    We look forward to hearing from you, and we will do our very best to get back to you as soon as
                    possible.</p>
                <ul class="row">
                    <li><input type="text" v-model="customForm.surname" placeholder="First name"></li>
                    <li><input type="text" v-model="customForm.name" placeholder="Last name"></li>
                    <li><input type="text" v-model="customForm.email" placeholder="Email"></li>
                    <li><input type="text" v-model="customForm.phone" placeholder="Phone"></li>
                    <li><input type="text" v-model="customForm.company" placeholder="Company"></li>
                    <li>
                        <select v-model="customForm.pos">
                            <option value="">Job title</option>
                            <option value="C-level">C-level</option>
                            <option value="Senior executive">Senior executive</option>
                            <option value="Service/Maintenance">Service/Maintenance</option>
                            <option value="Production">Production</option>
                            <option value="Technical">Technical</option>
                            <option value="IT">IT</option>
                            <option value="Finance">Finance</option>
                            <option value="Admin/Support staff">Admin/Support staff</option>
                            <option value="Other">Other</option>
                        </select>
                    </li>
                    <li>
                        <select v-model="customForm.type">
                            <option value="">Industry</option>
                            <option value="Poultry">Poultry</option>
                            <option value="Meat">Meat</option>
                            <option value="Fish">Fish</option>
                            <option value="Other">Other</option>
                        </select>
                    </li>
                    <li>
                        <select v-model="customForm.area">
                            <option value="">Country</option>
                            <option value="Afghanistan">Afghanistan</option>
                            <option value="Albania">Albania</option>
                            <option value="Algeria">Algeria</option>
                            <option value="Angola">Angola</option>
                            <option value="Argentina">Argentina</option>
                            <option value="Armenia">Armenia</option>
                            <option value="Australia">Australia</option>
                            <option value="Austria">Austria</option>
                            <option value="Azerbaijan">Azerbaijan</option>
                            <option value="Bahamas">Bahamas</option>
                            <option value="Bahrain">Bahrain</option>
                            <option value="Bangladesh">Bangladesh</option>
                            <option value="Barbados">Barbados</option>
                            <option value="Belarus">Belarus</option>
                            <option value="Belgium">Belgium</option>
                            <option value="Belize">Belize</option>
                            <option value="Benin">Benin</option>
                            <option value="Bhutan">Bhutan</option>
                            <option value="Bolivia">Bolivia</option>
                            <option value="Bonaire, Sint Eustatius and Saba">Bonaire, Sint Eustatius and Saba
                            </option>
                            <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                            <option value="Botswana">Botswana</option>
                            <option value="Brazil">Brazil</option>
                            <option value="Brunei Darussalam">Brunei Darussalam</option>
                            <option value="Bulgaria">Bulgaria</option>
                            <option value="Burkina Faso">Burkina Faso</option>
                            <option value="Burundi">Burundi</option>
                            <option value="Cambodia">Cambodia</option>
                            <option value="Cameroon">Cameroon</option>
                            <option value="Canada">Canada</option>
                            <option value="Central African Republic">Central African Republic</option>
                            <option value="Chad">Chad</option>
                            <option value="Chile">Chile</option>
                            <option value="China">China</option>
                            <option value="Colombia">Colombia</option>
                            <option value="Congo (Democratic Republic)">Congo (Democratic Republic)</option>
                            <option value="Costa Rica">Costa Rica</option>
                            <option value="Croatia">Croatia</option>
                            <option value="Cuba">Cuba</option>
                            <option value="Cyprus">Cyprus</option>
                            <option value="Czech Republic">Czech Republic</option>
                            <option value="Denmark">Denmark</option>
                            <option value="Djibouti">Djibouti</option>
                            <option value="Dominican Republic">Dominican Republic</option>
                            <option value="Ecuador">Ecuador</option>
                            <option value="Egypt">Egypt</option>
                            <option value="El Salvador">El Salvador</option>
                            <option value="Equatorial Guinea">Equatorial Guinea</option>
                            <option value="Eritrea">Eritrea</option>
                            <option value="Estonia">Estonia</option>
                            <option value="Ethiopia">Ethiopia</option>
                            <option value="Faroe Islands">Faroe Islands</option>
                            <option value="Fiji">Fiji</option>
                            <option value="Finland">Finland</option>
                            <option value="France">France</option>
                            <option value="French Guiana">French Guiana</option>
                            <option value="Gabon">Gabon</option>
                            <option value="Gambia">Gambia</option>
                            <option value="Georgia">Georgia</option>
                            <option value="Germany">Germany</option>
                            <option value="Ghana">Ghana</option>
                            <option value="Greece">Greece</option>
                            <option value="Greenland">Greenland</option>
                            <option value="Guadeloupe">Guadeloupe</option>
                            <option value="Guam">Guam</option>
                            <option value="Guatemala">Guatemala</option>
                            <option value="Guinea">Guinea</option>
                            <option value="Guinea-Bissau">Guinea-Bissau</option>
                            <option value="Guyana">Guyana</option>
                            <option value="Haiti">Haiti</option>
                            <option value="Honduras">Honduras</option>
                            <option value="Hong Kong">Hong Kong</option>
                            <option value="Hungary">Hungary</option>
                            <option value="Iceland">Iceland</option>
                            <option value="India">India</option>
                            <option value="Indonesia">Indonesia</option>
                            <option value="Iran">Iran</option>
                            <option value="Iraq">Iraq</option>
                            <option value="Ireland">Ireland</option>
                            <option value="Israel">Israel</option>
                            <option value="Italy">Italy</option>
                            <option value="Ivory Coast">Ivory Coast</option>
                            <option value="Jamaica">Jamaica</option>
                            <option value="Japan">Japan</option>
                            <option value="Jordan">Jordan</option>
                            <option value="Kazakhstan">Kazakhstan</option>
                            <option value="Kenya">Kenya</option>
                            <option value="Kiribati">Kiribati</option>
                            <option value="Kuwait">Kuwait</option>
                            <option value="Kyrgyzstan">Kyrgyzstan</option>
                            <option value="Laos">Laos</option>
                            <option value="Latvia">Latvia</option>
                            <option value="Lebanon">Lebanon</option>
                            <option value="Lesotho">Lesotho</option>
                            <option value="Liberia">Liberia</option>
                            <option value="Libya">Libya</option>
                            <option value="Liechtenstein">Liechtenstein</option>
                            <option value="Lithuania">Lithuania</option>
                            <option value="Luxembourg">Luxembourg</option>
                            <option value="Madagascar">Madagascar</option>
                            <option value="Malawi">Malawi</option>
                            <option value="Malaysia">Malaysia</option>
                            <option value="Mali">Mali</option>
                            <option value="Malta">Malta</option>
                            <option value="Marshall Islands">Marshall Islands</option>
                            <option value="Martinique">Martinique</option>
                            <option value="Mauritania">Mauritania</option>
                            <option value="Mauritius">Mauritius</option>
                            <option value="Mexico">Mexico</option>
                            <option value="Micronesia">Micronesia</option>
                            <option value="Moldova">Moldova</option>
                            <option value="Mongolia">Mongolia</option>
                            <option value="Montenegro">Montenegro</option>
                            <option value="Morocco">Morocco</option>
                            <option value="Mozambique">Mozambique</option>
                            <option value="Myanmar">Myanmar</option>
                            <option value="Namibia">Namibia</option>
                            <option value="Nepal">Nepal</option>
                            <option value="Netherlands">Netherlands</option>
                            <option value="New Zealand">New Zealand</option>
                            <option value="Nicaragua">Nicaragua</option>
                            <option value="Niger">Niger</option>
                            <option value="Nigeria">Nigeria</option>
                            <option value="North Korea">North Korea</option>
                            <option value="Norway">Norway</option>
                            <option value="Oman">Oman</option>
                            <option value="Pakistan">Pakistan</option>
                            <option value="Palestine">Palestine</option>
                            <option value="Panama">Panama</option>
                            <option value="Papua New Guinea">Papua New Guinea</option>
                            <option value="Paraguay">Paraguay</option>
                            <option value="Peru">Peru</option>
                            <option value="Philippines">Philippines</option>
                            <option value="Poland">Poland</option>
                            <option value="Portugal">Portugal</option>
                            <option value="Puerto Rico">Puerto Rico</option>
                            <option value="Qatar">Qatar</option>
                            <option value="Republic of North Macedonia">Republic of North Macedonia</option>
                            <option value="Romania">Romania</option>
                            <option value="Russian Federation">Russian Federation</option>
                            <option value="Rwanda">Rwanda</option>
                            <option value="Saudi Arabia">Saudi Arabia</option>
                            <option value="Senegal">Senegal</option>
                            <option value="Serbia">Serbia</option>
                            <option value="Seychelles">Seychelles</option>
                            <option value="Sierra Leone">Sierra Leone</option>
                            <option value="Singapore">Singapore</option>
                            <option value="Slovakia">Slovakia</option>
                            <option value="Slovenia">Slovenia</option>
                            <option value="Somalia">Somalia</option>
                            <option value="South Africa">South Africa</option>
                            <option value="South Korea">South Korea</option>
                            <option value="Spain">Spain</option>
                            <option value="Sri Lanka">Sri Lanka</option>
                            <option value="Sudan">Sudan</option>
                            <option value="Suriname">Suriname</option>
                            <option value="Swaziland">Swaziland</option>
                            <option value="Sweden">Sweden</option>
                            <option value="Switzerland">Switzerland</option>
                            <option value="Syria">Syria</option>
                            <option value="Taiwan">Taiwan</option>
                            <option value="Tajikistan">Tajikistan</option>
                            <option value="Tanzania">Tanzania</option>
                            <option value="Thailand">Thailand</option>
                            <option value="Timor-Leste">Timor-Leste</option>
                            <option value="Togo">Togo</option>
                            <option value="Tonga">Tonga</option>
                            <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                            <option value="Tunisia">Tunisia</option>
                            <option value="Turkey">Turkey</option>
                            <option value="Turkmenistan">Turkmenistan</option>
                            <option value="Uganda">Uganda</option>
                            <option value="Ukraine">Ukraine</option>
                            <option value="United Arab Emirates">United Arab Emirates</option>
                            <option value="United Kingdom">United Kingdom</option>
                            <option value="United States of America">United States of America</option>
                            <option value="Uruguay">Uruguay</option>
                            <option value="Uzbekistan">Uzbekistan</option>
                            <option value="Venezuela">Venezuela</option>
                            <option value="Viet Nam">Viet Nam</option>
                            <option value="Western Sahara">Western Sahara</option>
                            <option value="Yemen">Yemen</option>
                            <option value="Zambia">Zambia</option>
                            <option value="Zimbabwe">Zimbabwe</option>
                        </select>
                    </li>
                    <li>
                        <textarea v-model="customForm.mess" placeholder="Message"></textarea>
                    </li>
                </ul>
                <button @click="addCustomFuc">Submit</button>
            </div>
        </div>
        <!-- 联系表单区域 -->
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { listProducts2, addCustom } from '@/api';
export default {
    name: 'ProductContent',
    data() {
        return {
            customForm: {
                surname: '',
                name: '',
                email: '',
                phone: '',
                company: '',
                pos: '',
                type: '',
                area: '',
                mess: '',
                state: 0
            },
            nowType: -1,
            nowPge: 1,
            nowPsz: 12,
            maxSize: 0,
            typeList: [],
            // 搜索相关（如需全局搜索，建议移到全局组件/状态）
            searchVisible: false,
            searchKeyword: '',
            // 侧边分类
            activeCategory: 0, // 默认展开第一个分类
            isSideOn: false,
            isSideOnA: false,
            // 产品列表数据
            productList: [],
            // 分页
            currentPage: 1,
            totalPages: 6,
            // 联系表单
            formData: {
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                company: '',
                jobTitle: '',
                industry: '',
                country: '',
                message: ''
            },
            // 滚动位置缓存
            scrollPosition: 0,
            // 公共头部高度（需从父组件传入，或根据实际项目配置）
            headerHeight: 120, // 示例值，需根据实际顶栏高度调整
            searchKey: ''
        }
    },
    props: {
        // 可接收父组件传入的公共头部高度
        parentHeaderHeight: {
            type: Number,
            default: 120
        }
    },
    watch: {
        parentHeaderHeight(newVal) {
            this.headerHeight = newVal
            // 高度变化时重新计算滚动状态
            this.handleScroll()
        }
    },
    beforeMount() {
        this.nowType = this.$route.query.type || -1;
        this.searchKey = this.$route.query.txt || '';
    },
    mounted() {

        window.scrollTo(0, 0)
        // 添加滚动监听
        window.addEventListener('scroll', this.handleScroll)
        // 初始化时执行一次滚动判断
        this.handleScroll();
        // 初始化时获取产品类型列表
        this.listProductsFuc();
    },
    beforeDestroy() {
        // 移除滚动监听
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        async addCustomFuc() {
            if (this.customForm.mess == '') {
                this.$message({
                    message: 'Please enter your message!',
                    type: 'error'
                });
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await addCustom(this.customForm);
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: 'Send Success！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                    window.scrollTo(0, 0)
                }, 1000);
            } else {
                this.$message({
                    message: data.message || '添加失败',
                    type: 'error'
                });
            }
        },
        handleSizeChange(val) {
            this.nowPsz = val;
            this.listProductsFuc();
        },
        handleCurrentChange(val) {
            this.nowPge = val;
            this.listProductsFuc();
        },
        handleTypeClick(item) {
            this.nowType = item.id;
            this.nowPge = 1;
            this.listProductsFuc();
        },
        async listProductsFuc() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await listProducts2({
                key: this.searchKey || '',
                pge: this.nowPge,
                psz: this.nowPsz,
                type: this.nowType
            });
            loading.close();
            if (data.code == 200) {
                this.productList = data.data || [];
                this.maxSize = data.count || 0;
                this.typeList = data.type || [];
                window.scrollTo(0, 0);
            } else {
                this.$message.error(data.message || '获取产品列表失败');
            }
        },
        // ========== 滚动相关（适配无公共顶栏的场景） ==========
        handleScroll() {
            // 获取滚动距离
            this.scrollPosition = window.scrollY || document.documentElement.scrollTop

            // 获取元素位置（仅依赖内容区域自身元素）
            const productListEl = this.$refs.productList
            const contactBlockEl = this.$refs.contactBlock
            const lmNrEl = document.querySelector('.lm_nr')

            if (!productListEl || !contactBlockEl || !lmNrEl) return;

            // 重新计算临界值（移除对公共顶栏元素的依赖）
            // lg: 侧边栏开始固定的滚动位置
            const lg = productListEl.offsetTop - this.headerHeight - 30;
            // gd: 侧边栏切换为绝对定位的滚动位置
            const gd = contactBlockEl.offsetTop - lmNrEl.offsetHeight - this.headerHeight - 70;

            // 更新侧边栏class
            this.isSideOn = this.scrollPosition > 50
            this.isSideOnA = this.scrollPosition > gd
        },

        // ========== 搜索功能（如需全局搜索，建议移到全局组件） ==========
        toggleSearch() {
            this.searchVisible = !this.searchVisible
            if (this.searchVisible) {
                this.$nextTick(() => {
                    const searchInput = document.querySelector('.sc_nr input')
                    if (searchInput) searchInput.focus()
                })
            }
        },

        handleSearch() {
            if (!this.searchKeyword.trim()) {
                alert('Please enter search keywords')
                return
            }
            console.log('Search:', this.searchKeyword)
            this.searchVisible = false
            // 可通过emit通知父组件执行搜索逻辑
            this.$emit('search', this.searchKeyword)
        },

        // ========== 侧边分类展开/收起 ==========
        toggleCategory(index) {
            console.log(index)
            this.activeCategory = index;
        },

        // ========== 分页逻辑 ==========
        changePage(page) {
            if (page < 1 || page > this.totalPages) return
            this.currentPage = page
            // 分页切换后滚动到产品列表顶部
            this.$nextTick(() => {
                this.$refs.productList.scrollIntoView({ behavior: 'smooth' })
            })
            // 通知父组件分页变化
            this.$emit('page-change', page)
        },

        // ========== 表单提交 ==========
        handleFormSubmit() {
            // 基础验证
            if (!this.formData.firstName || !this.formData.lastName || !this.formData.email) {
                alert('First name, Last name and Email are required!')
                return
            }

            // 邮箱格式验证
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!emailRegex.test(this.formData.email)) {
                alert('Please enter a valid email address!')
                return
            }

            // 通知父组件提交表单
            this.$emit('form-submit', { ...this.formData })

            // 提交成功提示并重置
            alert('Thank you for your message! We will contact you soon.')
            this.formData = {
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                company: '',
                jobTitle: '',
                industry: '',
                country: '',
                message: ''
            }
        }
    },
    computed: {
        ...mapState(['productTypes']),
        typeDataFive() {
            return this.productTypes.slice(0, 5);
        }
    }
}
</script>


<style>
.lm_nr.on {
    position: fixed;
    top: calc(30px + var(--header-height, 120px));
    /* 适配顶栏高度 */
    z-index: 99;
}

.lm_nr.on_a {
    position: absolute;
    top: auto;
    bottom: 0;
}

.com-aonaer-wm-pagination {
    height: fit-content;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
}
</style>